import template from './floor.jade';
import validation from '../../../../services/validation';

export default angular
  .module('cian.addForm.helperFloor', [])
  .directive('cianAfHelperFloor', [
    'isSimpleFormEnabled', '$rootScope',
    (isSimpleFormEnabled, $rootScope) =>
  ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
      minFloor: '=',
    },
    link: {
      pre(scope, element, attrs, ctrl) {
        ctrl.minFloorStrict = attrs.minFloorStrict !== 'false';
      },
    },
    controller(deviceService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      // TODO we need general approach for this kind of situations
      if (!this.ad.building) {
        this.ad.building = {};
      }

      this.isSimpleFormEnabled = isSimpleFormEnabled;
      this.isCoworking = !!this.ad.coworkingOfferType;

      this.floorsCountBlured = false;
      this.floorNumberBlured = false;
      this.minFloorNumber = this.minFloor;
      this.maxFloorNumber = 999;
      this.maxFloorsCount = 999;

      this.getMinFloorsCount = () => {
        return this.ad.floorNumber ? Math.max(1, this.ad.floorNumber) : 1;
      };

      const isBothRequired = () => {
        return this.floorNumberValidation.invalid() && this.floorsCountValidation.invalid() &&
              this.form['floorNumber'].$error.required && this.form['floorsCount'].$error.required;
      };

      const isInvalid = () => {
        if (this.floorsValidation && this.ad.building.floorsCount !== null && this.ad.floorNumber !== null) {
          return this.ad.building.floorsCount < this.ad.floorNumber;
        }

        return false;
      };

      this.floorNumberValidation = validation(this.form, 'floorNumber', {
        parse: 'Введите число',
        required: 'Введите этаж',
        min: `Этаж должен быть больше ${this.minFloorNumber}`,
        max: 'Допустимо не более 3 символов',
        notZero: 'Введите -1 или -2 для подвала или полу-подвала',
      });

      this.floorsCountValidation = validation(this.form, 'floorsCount', {
        parse: 'Введите число',
        required: 'Введите количество этажей в доме',
        min: 'Количество этажей не может быть меньше 1',
        max: 'Допустимо не более 3 символов',
      });

      this.blurField = field => {
        if (field === 'floorsCount') {
          this.floorsCountBlured = true;
        } else {
          this.floorNumberBlured = true;
        }
        if (this.floorsCountBlured && this.floorNumberBlured) {
          setMinFloorsCountValidation();
        }
      };

      const setMinFloorsCountValidation = () => {
        this.floorsValidation = validation(this.form, 'floorsCount', {
          min: 'Этаж объекта недвижимости должен быть меньше или равен этажности здания',
        });
      };

      this.floorNumberValidationInvalid = () => {
        return this.floorNumberValidation.invalid() || isInvalid();
      };

      this.floorNumberValidationShowTooltip = () => {
        return this.floorNumberValidation.invalid() && !isBothRequired();
      };

      this.floorsCountValidationInvalid = () => {
        return this.floorsCountValidation.invalid() || isInvalid();
      };

      this.floorsCountValidationShowTooltip = () => {
        return this.floorsCountValidationInvalid() && (!this.floorNumberValidation.invalid() || isBothRequired());
      };

      this.floorsCountValidationMessage = () => {
        let message;
        if (isBothRequired()) {
          message = 'Укажите этаж и количество этажей в доме';
        }
        else if (isInvalid()) {
          message = this.floorsValidation.message();
        }
        else {
          message = this.floorsCountValidation.message();
        }
        return message;
      };

      $rootScope.$on('addform.submit', () => {
        setMinFloorsCountValidation();

        if (isInvalid()) {
          this.floorsCountBlured = true;
          this.floorNumberBlured = true;
        }
      });
    },
    controllerAs: 'floor',
    template,
  })])
  .name;
